import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import InfoUsersApi from '../api/user/info_users.ts';

export const fetchUsersAsync = createAsyncThunk(
    'user/fetchUsers',
    async (office_id) => {
        const response = await InfoUsersApi(office_id);
        return response;
    }
);

const userDataSlice = createSlice({
    name: 'users',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        update_status: (state, action) => {
            const { userId, newStatus } = action.payload;
            const user = state.data.find(u => u.id_user === userId);
            if (user) {
                user.status = newStatus;
            }
        },
        // Paso 5: reducer para actualizar los campos editables de un usuario en el store
        update_user: (state, action) => {
            const updated = action.payload;
            const idx = state.data.findIndex(u => u.id_user === updated.id_user);
            if (idx !== -1) {
                state.data[idx] = { ...state.data[idx], ...updated };
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUsersAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchUsersAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchUsersAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default userDataSlice.reducer;

export const { update_status, update_user } = userDataSlice.actions;
